module.exports = __webpack_public_path__ + "media/partners/renowacjafelg-bg-small-34cc7d6c.png";